/**
 * 运维大盘子站公网入口
 * 开发推荐：http://localhost:4000/ops-center/（主站同源反代，Cookie 一致）
 */
export function getOpsCenterPublicUrl(): string {
  if (typeof window === 'undefined') return '/ops-center/'
  const host = window.location.hostname
  if (host === 'localhost' || host.includes('192.168')) {
    return `http://${host}:4000/ops-center/`
  }
  return `${window.location.origin}/ops-center/`
}

/**
 * 登录成功后安全回跳（生产：/ops-center 路径；开发：允许 localhost ops-center 完整 URL）
 */
export function resolveSafeLoginRedirect(raw: unknown): string | null {
  if (typeof raw !== 'string' || !raw) return null

  if (raw.startsWith('/ops-center') && !raw.startsWith('//')) {
    return raw
  }

  try {
    const url = new URL(raw)
    if (!url.pathname.startsWith('/ops-center')) return null
    const host = url.hostname
    if (host === 'localhost' || host.includes('192.168') || host === '127.0.0.1') {
      return raw
    }
  } catch {
    return null
  }

  return null
}
